import { apiGet } from 'api';
import { GetResponseDocumentRequest, GetResponseDocumentResponse } from '../../types';

export const getResponseDocument = (
  request: GetResponseDocumentRequest
): Promise<GetResponseDocumentResponse> =>
  apiGet<GetResponseDocumentResponse>(
    `consultations/${request.consultationId}/response/${request.responseId}/document/${request.documentId}`
  );
